const getRandom = (array: string[]): string => {
  return array[Math.floor(Math.random() * array.length)] as string;
};

export const REFERRALS = {
  CHASE: {
    SAPPHIRE: getRandom(["https://www.referyourchasecard.com/19y/EKRQ5CG4B4"]),
    INKS: getRandom([
      "https://www.referyourchasecard.com/21h/MFO0MKM5P8",
      "https://www.referyourchasecard.com/21h/5VJ6YKSC2W",
      "https://www.referyourchasecard.com/21h/ERBI10GEF5",
      "https://www.referyourchasecard.com/21h/9OUQEQMI9D",
    ]),
    FREEDOM: getRandom(["https://www.referyourchasecard.com/18s/A85BX0FG21"]),
    UNITED: getRandom(["https://www.referyourchasecard.com/215s/OPTN75PXFL"]),
    SOUTHWEST: getRandom([
      "https://www.referyourchasecard.com/226j/K4WKAUC2ML",
    ]),
    MARRIOTT: getRandom(["https://www.referyourchasecard.com/252x/7X26JH6QGV"]),
  },
  AMERICAN_EXPRESS: {
    BLUE_BUSINESS_PLUS: getRandom([
      "https://americanexpress.com/en-us/referral/bluebusinessplus-credit-card?ref=ANDENatbcn&xl=cp15",
    ]),
  },
  DISCOVER: getRandom(["https://refer.discover.com/aacitelli3!a9f01e6210!a"]),
};
